var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('center',[_c('v-alert',{attrs:{"border":"left","colored-border":"","color":"deep-purple accent-4","elevation":"2","max-width":"700"}},[_vm._v(" "+_vm._s(_vm.$t(("App.fhir-resources-texts." + _vm.title)))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }